<script setup lang="ts">
import PostPage from '~/pages/post/[slug].vue'
</script>

<template>
  <PostPage />
</template>
